export default __webpack_public_path__ + "static/media/ic-publish-1.9738c19b.svg";